module.exports = __webpack_public_path__ + "static/img/cont602.b3e5230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont602.jpg
// module id = kRb1
// module chunks = 0